import React from 'react'
import TreeView from '@zippytech/react-toolkit/TreeView'
import '@zippytech/react-toolkit/TreeView/index.css'
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';

class SettingTree extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPath: 0,
            selectedId: null
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }


    nodeStyle = (nodeProps) => {
        if (nodeProps.node._id === this.state.selectedId) {
            return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
        } else {
            return { color: '#6b6b6b', fontWeight: 'normal', fontFamily: 'montserrat-normal' }
        }

    }
    async onSelectionChange(selectedMap) {

        this.setState({ selectedId: selectedMap.node._id ? selectedMap.node._id : null })
        const history = this.props.history;
        if (selectedMap.node && selectedMap.node.treeId === 'Knowledge Bank') {
            await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
            await dispatch.community.setMainAreaContext("knowledgeBank");
            await dispatch.account.setIsCategoryChange(false);
            dispatch.app.setCurrentContext("pf-kb-setting");
            history.push(`/app/platform/settings/public`)
        }
        else if (selectedMap.node && selectedMap.node.baseCategory) {
            await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
            await dispatch.community.setMainAreaContext("baseCategory");
            await dispatch.account.setIsCategoryChange(true);
            dispatch.app.setCurrentContext("pf-kb-setting");
            await dispatch.account.setTreeIdFromParams({
                baseCategoryId: selectedMap.node.id,
            })
            history.push(`/app/platform/settings/public/${selectedMap.node.id}`)
        }
        else if (selectedMap.node && selectedMap.node.category) {
            await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
            await dispatch.community.setMainAreaContext("category");
            await dispatch.account.setIsCategoryChange(true);
            dispatch.app.setCurrentContext("pf-kb-setting");
            await dispatch.account.setTreeIdFromParams({
                baseCategoryId: selectedMap.parent.node.id,
                categoryId: selectedMap.node.id,
            })
            history.push(`/app/platform/settings/public/${selectedMap.parent.node.id}/${selectedMap.node.id}`)
        }
        else if (selectedMap.node && selectedMap.node.subCategory) {
            await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
            await dispatch.community.setMainAreaContext("subCategory");
            await dispatch.account.setIsCategoryChange(false);
            await dispatch.account.setTreeIdFromParams({
                baseCategoryId: selectedMap.parent.parent.node.id,
                categoryId: selectedMap.parent.node.id,
                subCategoryId: selectedMap.node.id,
            })
            dispatch.app.setCurrentContext("pf-kb-setting");
        }
        else if (selectedMap.node && selectedMap.node.treeId === 'IntegrationList') {
            await dispatch.community.setMainAreaContext("Integration");
            dispatch.app.setCurrentContext("pf-Integration-setting");
            history.push(`/app/platform/settings/integration`)
        }
        else if (selectedMap.node && selectedMap.node.treeId === 'Integration') {
            await dispatch.community.setMainAreaContext(selectedMap.node.value);
            dispatch.app.setCurrentContext("pf-Integration-setting");
            history.push(`/app/platform/settings/integration/${selectedMap.node.value}`)
        }
        else if (selectedMap.node && selectedMap.node.treeId === 'SystemNotification') {
            await dispatch.community.setMainAreaContext(selectedMap.node.value);
          //  dispatch.app.setCurrentContext("pf-Integration-setting");
            history.push(`/app/platform/settings/systemnotification/${selectedMap.node.value}`)
        }
        // below changes made for KLM-9068
        else if (selectedMap.node && selectedMap.node.treeId === 'Pricing') {
            await dispatch.community.setMainAreaContext(selectedMap.node.value);
          //  dispatch.app.setCurrentContext("pf-Integration-setting");
            history.push(`/app/platform/settings/pricing-page`)
        }
        else if (selectedMap.node && selectedMap.node.treeId === 'consumptionDashboard') {
            await dispatch.community.setMainAreaContext(selectedMap.node.value);
            history.push(`/app/platform/settings/consumption-dashboard`)
        }
        else if (selectedMap.node && selectedMap.node.treeId === 'consumptionBilling') {
            await dispatch.community.setMainAreaContext(selectedMap.node.value);
            history.push(`/app/platform/settings/consumption-billing`)
        }
        else {
            await dispatch.account.setSelectedCategoryAsync({});
            await dispatch.community.setMainAreaContext("");
            dispatch.app.setCurrentContext("");
        }

    }

    componentWillMount() {
        dispatch.account.setIsCategoryChange(false);
        dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": this.props.match.params.accountId, isPublic: true, accountOnly: true });
        dispatch.account.getAccountTagsTree({})
    }

    render() {
        const components = [

            {
                _id: 1,
                label: "Public Knowledge Banks",
                value: 'Knowledge Bank',
                nodes: this.props.categoryTree,
                treeId: "Knowledge Bank"
            },
            {
                _id: 2,
                label: "Integration",
                value: "Integration",
                treeId: "IntegrationList",

            },
            {
                _id: 3,
                label: "Notifications",
                value: "",
                treeId: "SystemNotification",

            },
            {
                _id: 4,
                label: "Pricing",
                value: "",
                treeId: "Pricing",

            },
            {
                _id: 5,
                label: "Consumption Dashboard",
                value: "",
                treeId: "consumptionDashboard",

            },
            {
                _id: 6,
                label: "Consumption Billing",
                value: "",
                treeId: "consumptionBilling",

            },
        ];


        return (
            <div>
                <TreeView
                    leafNodeIcon={
                        <svg fill="#000000" height="16" viewBox="0 0 24 24" width="22" style={{ verticalAlign: 'middle', overflow: 'inherit' }}>
                            <path d="M 0 10 20 10" stroke="#F6F6F6" strokeWidth="1" fill="none" />
                        </svg>
                    }
                    className="browserPane"
                    enableSelection={true}
                    nodeStyle={this.nodeStyle}
                    onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
                    dataSource={components}
                    singleSelect={true}
                    enableHoverStyle={false}
                    enableKeyboardNavigation={false}
                    defaultCollapsedDepth={1}
                />

                {/* {this.props.isAddCategoryModalOpen ?
                    <AddCategoryModal
                        isAddCategoryModalOpen={this.props.isAddCategoryModalOpen}
                        user={this.props.user}
                        accountId={this.props.selectedAccount._id}
                        categoryType={this.props.mainAreaContext}
                        baseCategory={this.props.baseCategoriesArr}
                        categories={this.props.categoriesArr}
                        subCategories={this.props.subCategoriesArr}
                        selectedCategory={this.props.selectedCategory}
                        categoryTreeId={this.props.categoryTreeId}
                        loading={this.props.addCategoryLoader}
                        history={this.props.history}
                    />
                    : ''
                } */}

                {/* {this.props.isDeleteCategoryModalOpen ?
                    <DeleteCategoryModal
                        isDeleteCategoryModalOpen={this.props.isDeleteCategoryModalOpen}
                        user={this.props.user}
                        accountId={this.props.selectedAccount._id}
                        selectedCategory={this.props.selectedCategory}
                        categoryTreeId={this.props.categoryTreeId}
                        history={this.props.history}
                        loading={this.props.deleteLoader}
                        categoryType={this.props.mainAreaContext}
                    // categoryTree={this.props.categoryTree}
                    />
                    : ''
                } */}
            </div>
        );
    }
}
export default withRouter(SettingTree);

